import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SalesGraphRes;
export const SalesGraphTodo = createAsyncThunk('SalesGraph', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_month_wise_purchase',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcustomer_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vyear_start_date": "2024-04-01 00:00:00.000",
                "vyear_end_date": "2025-03-31 00:00:00.000"

            }
        })
        return SalesGraphRes = res.data

    } catch (error) {
        return SalesGraphRes = error.response.data
    }
});

const SalesGraphSlice = createSlice({
    name: 'SalesGraph',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SalesGraphTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(SalesGraphTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SalesGraphSlice.reducer; 